import { render, staticRenderFns } from "./documentoModal.vue?vue&type=template&id=3f93d573&"
import script from "./documentoModal.vue?vue&type=script&lang=js&"
export * from "./documentoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports